'use client';

import { SignInDialog } from "@eliadmin/core/src/components/dialog/lazy-dialogs";
import Link from '@eliadmin/core/src/components/link';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { useDialogStore } from '@eliadmin/core/src/components/ui/dialog';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { isCurriculumCompleted } from '../../utils/curriculum-utils';

export function JobPortalCreateCurriculumButton() {
  const { t } = useTranslations();
  const { isInitialized, me } = useCustomerStore();
  const openDialog = useDialogStore(state => state.open);
  const customer = me?.customer;
  const curriculumCompleted = isCurriculumCompleted(customer);
  const shouldHighlight = customer?.customer_type?.type === 'student' && !curriculumCompleted;

  const handleSignInClick = () => {
    openDialog({
      id: SignInDialog.id,
      content: <SignInDialog />,
    });
  };

  if (!isInitialized) return null;

  if (!me) {
    return (
      <div className="flex w-full justify-end">
        <Button className="h-[52px] w-full px-6" onClick={handleSignInClick}>
          {t('text833')}
        </Button>
      </div>
    );
  }

  if (customer?.customer_type?.type === 'company') {
    return (
      <div className="flex w-full justify-end">
        <Button className="h-[52px] w-full whitespace-nowrap px-6" asChild>
          <Link href={ROUTES.CREATE_OFFER()}>{t('text1569')}</Link>
        </Button>
      </div>
    );
  }

  return (
    <div className="flex w-full flex-grow justify-end sm:flex-grow-0">
      <Button className="h-[52px] w-full whitespace-nowrap px-6" asChild>
        <Link href={curriculumCompleted ? ROUTES.CURRICULUM_EDIT() : ROUTES.CURRICULUM_CREATE()}>
          <span
            className={cn(
              'inline-block',
              shouldHighlight && '[animation-duration:1.4s] motion-safe:animate-bounce',
            )}
          >
            {curriculumCompleted ? t('text2443') : t('text833')}
          </span>
        </Link>
      </Button>
    </div>
  );
}
